module.exports = __webpack_public_path__ + "static/logo-6cd1a8be139efdec483b56cc3172816d.png";